<div class="p-3">
  <h2 class="text-lg font-bold">{{ '#TRANSPORT.DIALOGS.ADD_ITEM.TITLE' | translate }}</h2>
</div>
<div
  class="soft-list p-3 w-full max-h-[60vh] overflow-y-auto soft-scroll soft-scroll-vertical soft-scroll no-horizontal mb-12 pb-4"
>
  @if (items$ | async; as items) {
    @if ((items?.length ?? 0) < 1) {
      <div class="placeholder-container">
        <span class="color-light">
          {{ '#TRANSPORT.DIALOGS.ADD_ITEM.ALREADY_ADDED' | translate }}
        </span>
      </div>
    } @else {
      @for (item of items; track item) {
        <div class="soft-list-item border-b p-2" (click)="toggleSelect(item)">
          <div class="flex flex-col justify-center">
            <strong>
              {{
                !item?.artikel?.bezeichnung || item?.artikel?.bezeichnung === ''
                  ? 'Keine Artikelbezeichnung'
                  : item?.artikel?.bezeichnung
              }}
            </strong>
            <span class="text-sm color-light">
              {{ '#TRANSPORT.DIALOGS.ADD_ITEM.ITEM_NUMBER_PREFIX' | translate }}
              {{ item?.artikel?.artikelnummer }}
            </span>
          </div>
          <soft-checkbox
            [checked]="isItemSelected(item)"
            (valueChange)="toggleSelect(item)"
            (click)="$event.stopPropagation()"
          />
        </div>
      }
    }
  }
</div>

<div class="flex w-full">
  <button type="button" class="soft-button secondary w-full h-14" (click)="close(null)">
    {{ '#TRANSPORT.SHARED.CANCEL' | translate }}
  </button>
  @if (((items$ | async)?.length ?? 0) > 0) {
    <button
      type="button"
      class="soft-button primary w-full h-14"
      (click)="closeDialog()"
      [disabled]="!atLeastOneItemSelected"
    >
      {{ '#TRANSPORT.DIALOGS.ADD_ITEM.SAVE' | translate }}
    </button>
  }
</div>
